import {
  FiltersMap,
  KeyedItem,
  QueryState,
  syncWithSharedQuery,
  TaskState,
} from '@wix/bex-core';
import { NestedTableLevelDescriptor } from './NestedTableLevelDescriptor';

export interface NestedTableFlatDataItem<
  C extends string,
  T,
  F extends FiltersMap,
> {
  state: NestedTableFlatModeSectionState<C, T, F>;
  originalKeyedItem: KeyedItem<T>;
}

export type NestedTableFlatKeyedItem<
  C extends string,
  T,
  F extends FiltersMap,
> = KeyedItem<NestedTableFlatDataItem<C, T, F>>;

export interface NestedTableFlatModeSectionStateParams<
  C extends string,
  T,
  F extends FiltersMap,
> {
  readonly levelDescriptor: NestedTableLevelDescriptor<C, T, F>;
  readonly query: QueryState<{}>;
}

export class NestedTableFlatModeSectionState<
  C extends string,
  T,
  F extends FiltersMap,
> {
  collection;
  readonly levelDescriptor;

  readonly initTask = new TaskState();

  constructor(params: NestedTableFlatModeSectionStateParams<C, T, F>) {
    const { levelDescriptor } = params;
    this.levelDescriptor = levelDescriptor;

    const { collection } = levelDescriptor.createCollection();
    this.collection = collection;

    const { query: sharedQuery } = params;

    const { query } = collection;

    syncWithSharedQuery(query, sharedQuery);
  }

  get query() {
    return this.collection.query;
  }

  get columns() {
    return this.levelDescriptor.columns;
  }

  get renderMainColumn() {
    return this.levelDescriptor.renderMainColumn;
  }

  get breadcrumbs() {
    return this.levelDescriptor.breadcrumbs;
  }

  init() {
    const { collection } = this;
    const disposers = [collection._optimisticActions?.init()];

    return () => {
      disposers.forEach((d) => d?.());
    };
  }
}
